export default __webpack_public_path__ + "pi1-1QAAT/components/SocialProof/images/address-relevance-66110af38953faec79ea6c77d27ba47f.svg";